<template>
   <div class="filter-wrap-date">
      <div class="field date">
         <label class="field-name">From</label>
         <date-time-picker class="form-control datepicker" :options="dateOptions"  v-model="from" @focus="onFocus(true)" @blur="onFocus(false)" :class="focus ? 'no-icon': ''"/>
      </div>
      <div class="field date">
         <label class="field-name">To</label>
         <date-time-picker class="form-control datepicker" :options="dateOptions" v-model="to" :class="focus ? 'no-icon': ''" @focus="onFocus(true)" @blur="onFocus(false)"/>
      </div>
   </div>
</template>

<script>

    import DateTimePicker from "./DateTimePicker";

    export default {
        name: 'filter-date',
        components: {DateTimePicker},

        watch : {
            from: function (newVal) {
                if (this.from.length || this.to.length) {
                    this.focus = true
                }
                this.$emit('update:modelValue', {from:newVal, to: this.to});
            },
            to: function (newVal) {
                if (this.from.length || this.to.length) {
                    this.focus = true
                }
                this.$emit('update:modelValue',{from: this.from, to: newVal});
            }
        },
        
        props: {
        },

        data() {
            return {
                from: '',
                to: '',
                focus: false,
                timeOptions: {

                },
                dateOptions: {
                    //datepicker: false,
                    timepicker: true,
                    format: 'Y-m-d H:i',
                    //minDate: new Date()
                },
            };
        },
        methods: {
            onFocus(value) {
                this.focus = value;
                if (this.from.length || this.to.length) {
                    this.focus = true
                }
            }
        }

    };
</script>

